<template>
	<div>
		<div v-if="title" class="title-item d-flex justify-content-between" :class="{ 'item-expanded': !collapsed }" @click="collapsed = !collapsed">
			<div class="d-flex align-items-center">
				<span>{{ title }}</span>
			</div>
			<span class="collapse-toggler mr-auto text-primary" :class="{ 'collapsed': collapsed }"><i class="fas fa-chevron-left"></i></span>
		</div>

		<ul v-if="!collapsed" class="tree-list" :class="{ 'pr-4': title }">
			<li v-for="column in nonCollectionColumns" :key="column.path" class="tree-item" :class="{ 'is-collection': isCollection && column.type !== 'Object' }" :title="column.title">
				<label v-if="column.type !== 'Object'" class="m-0 d-flex align-items-center">
					<input class="qd-checkbox" type="checkbox" :checked="selectedItems.find((x) => x.path === column.path)" :disabled="selectedItems.find((x) => !x.fromVariable && x.baseEntity !== baseEntity)" @change="(e) => checkBoxChanged(e, column)" />
					<span style="margin-right:3px">{{ column.title }}</span>
				</label>
				<div v-else>
					<entity-column-selector :title="column.title" :baseEntity="baseEntity" :path="`${path}${(column.name.toLowerCase() != column.objectEntityType.toLowerCase() ? `{'fk':'${column.name}Id'}` : '')}.${column.objectEntityType}`" :titlePath="`${titlePath}.${column.title}`" :columns="prepareColumns(column.objectEntityType)" :selectedItems="selectedItems" @column-changed="(item) => $emit('column-changed', item)" @add-column="(item) => $emit('add-column', item)"
						@remove-column="(item) => $emit('remove-column', item)" />
				</div>
				<select class="qd-dropdown" v-if="isCollection && column.type !== 'Object'" v-model="column.aggregate" @change="(e) => aggregateChanged(e, column)">
					<option value="count">تعداد</option>
					<option value="sum">مجموع</option>
					<option value="min">کمترین</option>
					<option value="max">بیشترین</option>
					<option value="avg">میانگین</option>
				</select>
			</li>
			<li v-if="collectionColumns.length">فهرست ها</li>
			<li v-for="column in collectionColumns" :key="column.path" class="">
				<entity-column-selector :title="column.title" :baseEntity="baseEntity" :path="`${path}.${column.objectEntityType}*`" :titlePath="`${titlePath}.${column.title}`" :columns="prepareColumns(column.objectEntityType)" :isCollection="true" :selectedItems="selectedItems" @column-changed="(item) => $emit('column-changed', item)" @add-column="(item) => $emit('add-column', item)" @remove-column="(item) => $emit('remove-column', item)" />
			</li>
		</ul>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex'

	export default {
		name: 'EntityColumnSelector',
		props: {
			isCollection: {
				type: Boolean,
				default: false,
			},
			baseEntity: String,
			title: String,
			path: String,
			titlePath: String,
			columns: {
				type: Array,
				default: () => [],
			},
			selectedItems: {
				type: Array,
				default: () => [],
			},
		},
		emits: ['add-column', 'remove-column', 'column-changed'],
		data() {
			return {
				collapsed: true
			}
		},
		computed: {
			...mapGetters({ entitiesStructure: 'queryDesigner/entitiesStructure' }),
			nonCollectionColumns() {
				return this.columns
					.filter((column) => column.type !== 'Collection')
					.map((column) => {
						let titlePath = ''
						if (this.isCollection) {
							let reversedTitlePath = this.titlePath.split('.').reverse()
							for (let index = 0; index < reversedTitlePath.length - 1; index++) {
								reversedTitlePath[index] += 'ی'
							}
							titlePath = `${column.title} ${reversedTitlePath.join(' ')}`
						} else {
							titlePath = `${this.titlePath}.${column.title}`.split('.').reverse().join('.')
						}

						let findCol = this.selectedItems.find((x) => x.path === column.path)
						Object.assign(column, {
							path: `${this.path}.${column.name}`,
							titlePath: titlePath,
							aggregate: findCol ? findCol.aggregate : this.isCollection ? 'count' : '',
							baseEntity: this.baseEntity,
						})
						return column
					})
			},
			collectionColumns() {
				return this.columns
					.filter((column) => column.type === 'Collection')
					.map((column) => {
						let reversedTitlePath = this.titlePath.split('.').reverse()
						for (let index = 0; index < reversedTitlePath.length - 1; index++) {
							reversedTitlePath[index] += 'ی'
						}
						reversedTitlePath = reversedTitlePath.join(' ')
						Object.assign(column, {
							path: `${this.path}.${column.name}`,
							titlePath: `${column.title} ${reversedTitlePath}`,
							aggregate: 'count',
							baseEntity: this.baseEntity,
						})
						return column
					})
			},
			currentEntityType() {
				if (!this.path) return ''
				let split = this.path.split('.')
				return split[split.length - 1]
			},
		},
		mounted() {
			if (!this.title || this.selectedItems?.findIndex(x => x.path.indexOf(this.path) > -1) > -1) {
				this.collapsed = false
			}
		},
		methods: {
			prepareColumns(entityType) {
				// remove props that have a parent same type for preventing circulate
				let item = this.entitiesStructure.find((x) => x.entityType === entityType)
				if (!item) return []
				let cloneColumns = item.columns
					.map((object) => ({ ...object }))
					.filter(x => x.objectEntityType !== this.currentEntityType
						&& x.objectEntityType !== entityType
						&& this.path.indexOf(`.${x.objectEntityType}.`) === -1
						&& this.path.indexOf(`.${x.objectEntityType}*.`) === -1)
				return cloneColumns
			},
			checkBoxChanged(e, column) {
				if (e.target.checked) {
					this.$emit('add-column', { ...column })
				} else {
					this.$emit('remove-column', column)
				}
			},
			aggregateChanged(e, column) {
				column.aggregate = e.target.value
				this.$emit('column-changed', { ...column })
			},
		},
	}
</script>

<style lang="less"></style>